import { Grid, Hidden, Paper } from "@mui/material";
import { useEffect } from "react";
import {
  useAccountBalanceData,
  useAccountData,
  useTransactionsData,
} from "../../../Hooks";
import { Loading, ScreenNotification } from "../../../Components/Atoms";
import ModalPin from "../Operators/ModalPin";
import { isDevelopmentOnly } from "../../../Utils/developmentFeature";
import { ErrorOutline } from "@mui/icons-material";
import { ReceiptList, ScreenGreeting } from "../../../Components/Molecules";
import { PixCardsDashboard } from "../../../Components/Molecules/PixCardsDashboard";

export const Dashboard = ({ }) => {
  const {
    state: accountData,
    handleGET: fetchAccountGET,
    loading: accountLoading,
  } = useAccountData();
  const {
    state: transactionsData,
    handleGET: fetchTransactionsGET,
    loading: transactionsLoading,
  } = useTransactionsData();
  const {
    state: accountBalanceData,
    handleGET: fetchAccountBalanceGET,
    loading: balanceLoading,
  } = useAccountBalanceData();

  useEffect(() => {
    fetchAccountGET();
    fetchTransactionsGET({ limit: 5 });
  }, []);

  if (accountLoading.GET || transactionsLoading.GET || balanceLoading.GET) {
    return <Loading />;
  }

  const topNotification = "";

  return (
    <>
      {isDevelopmentOnly && <ModalPin />}

      {!!topNotification && (
        <ScreenNotification
          icon={<ErrorOutline style={{ marginRight: 10 }} />}
          text={topNotification}
        />
      )}
      <ScreenGreeting
        title={"Detalhes das suas transações"}
        subTitle={
          "Aqui você poderá visualizar todos os detalhes de suas transações"
        }
      />

      <PixCardsDashboard />

      <Paper
        style={{
          minWidth: '100%',
          marginBottom: 20,
          marginTop: 20,
        }}
        elevation={3}
      >
        <ReceiptList
          headerLink="/extrato"
          itens={transactionsData}
          type="home"
          title="Últimas transações"
        />
      </Paper>
    </>
  )
};
